import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export type DeleteCenterProgramDocumentRequest = {
  id: number
  centerId: number
}

export function deleteCenterProgramDocument(input: DeleteCenterProgramDocumentRequest) {
  const { id, centerId } = input
  return restApiClient
    .url(
      constructApiUrl(API.centers.deleteCenterProgramDocument.url, {
        id: centerId,
        programDocumentFileId: id
      })
    )
    .delete()
}
